import NewGroupPage from './NewGroupPage';
export default NewGroupPage;
